import React from 'react';

export const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.3261 12C6.3261 11.7982 6.3659 11.6126 6.44552 11.4434C6.52514 11.2741 6.64457 11.1113 6.8038 10.9551L14.4571 3.60156C14.7158 3.35417 15.031 3.23047 15.4025 3.23047C15.6414 3.23047 15.8637 3.28906 16.0693 3.40625C16.275 3.52344 16.4409 3.68294 16.567 3.88477C16.6864 4.08008 16.7461 4.29818 16.7461 4.53906C16.7461 4.90365 16.6068 5.22266 16.3281 5.49609L9.51081 12L16.3281 18.5039C16.6068 18.7839 16.7461 19.1029 16.7461 19.4609C16.7461 19.7083 16.6864 19.9297 16.567 20.125C16.4409 20.3203 16.275 20.4766 16.0693 20.5938C15.8637 20.7109 15.6414 20.7695 15.4025 20.7695C15.031 20.7695 14.7158 20.6458 14.4571 20.3984L6.8038 13.0449C6.63793 12.8887 6.51851 12.7259 6.44552 12.5566C6.3659 12.3809 6.3261 12.1953 6.3261 12Z"
      fill="currentColor"
    />
  </svg>
);
